import { useEffect } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

export function ImageLightbox({ images, activeIndex, onChange, onClose }) {
  useEffect(() => {
    if (activeIndex === null) return undefined;
    const keydown = (event) => {
      if (event.key === "Escape") onClose();
      if (event.key === "ArrowRight") onChange((activeIndex + 1) % images.length);
      if (event.key === "ArrowLeft") onChange((activeIndex - 1 + images.length) % images.length);
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", keydown);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", keydown);
    };
  }, [activeIndex, images.length, onChange, onClose]);

  if (activeIndex === null) return null;
  const item = images[activeIndex];
  return (
    <div className="image-lightbox" role="dialog" aria-modal="true" aria-label="Galeria RC em movimento" data-testid="journal-lightbox-overlay" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <button type="button" className="lightbox-close" onClick={onClose} aria-label="Fechar imagem" data-testid="journal-lightbox-close-button"><X /></button>
      <button type="button" className="lightbox-arrow lightbox-arrow--left" onClick={() => onChange((activeIndex - 1 + images.length) % images.length)} aria-label="Imagem anterior" data-testid="journal-lightbox-previous-button"><ChevronLeft /></button>
      <figure className="image-lightbox__content" data-testid="journal-lightbox-content">
        <img src={item.src} alt={item.alt} data-testid="journal-lightbox-image" />
        <figcaption data-testid="journal-lightbox-caption"><span>RC em movimento</span><strong>{String(activeIndex + 1).padStart(2, "0")} / {String(images.length).padStart(2, "0")}</strong></figcaption>
      </figure>
      <button type="button" className="lightbox-arrow lightbox-arrow--right" onClick={() => onChange((activeIndex + 1) % images.length)} aria-label="Próxima imagem" data-testid="journal-lightbox-next-button"><ChevronRight /></button>
    </div>
  );
}